export interface Cms {
  isLoading: boolean;
  isShowSpinner: boolean;
  avatar: { photo: string, name: string };
  cmsContent: { [stepName: string]: { [id: string]: any } };
  isMobile: boolean;
}

export const initialState: Cms = {
  isLoading: false,
  isShowSpinner: false,
  avatar: null,
  cmsContent: {},
  isMobile: null,
};

export type CmsState = Readonly<Cms>;